import React from "react";

import ryderImg from "assets/images/MainLanding/ryder.png";
import envision from "assets/images/MainLanding/envision.png";
import sgImg from "assets/images/MainLanding/SG.png";
import ukg from "assets/images/MainLanding/ukg.png";
import bayview from "assets/images/MainLanding/bayview.png";

export default function PartnersSection() {
  return (
    <section className="partners-section">
      <div className="container">
        <div className="title">
          Our <span>client companies</span>
        </div>
        <div className="wrapper">
          <img src={envision} alt="" />
          <img src={ryderImg} alt="" />
          <img className="sg" src={sgImg} alt="" />
          <img src={ukg} alt="" />
          <img src={bayview} alt="" />
        </div>
      </div>
    </section>
  );
}
